<template>
  <v-form :submit="submitUpdate">
    <v-row density="compact">
      <v-col cols="12" lg="2" sm="4">
        <v-text-field
                      v-model="medical_record.height"
                      label="Altura (cm)"
                      type="number"
                      density="compact"
                      :disabled="requestingApi">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="2" sm="4">
        <v-text-field
                      v-model="medical_record.weight"
                      label="Peso (kg)"
                      type="number"
                      density="compact"
                      :disabled="requestingApi">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="3" sm="4">
        <v-autocomplete
                        label="Tipo sanguíneo"
                        :items="['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-']"
                        v-model="medical_record.blood_type"
                        :disabled="requestingApi"
                        density="compact">
          <template v-slot:no-data>
            <div class="px-4">Digite sua busca</div>
          </template></v-autocomplete>
      </v-col>
      <v-col cols="12" lg="3" sm="6">
        <v-text-field
                      v-model="medical_record.health_insurance_name"
                      label="Plano de saúde"
                      type="text"
                      :disabled="requestingApi"
                      density="compact"
                      hide-details>
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="2" sm="6">
        <v-text-field
                      v-model="medical_record.health_insurance_number"
                      label="Número"
                      type="text"
                      :disabled="requestingApi"
                      density="compact"
                      hide-details>
        </v-text-field>
      </v-col>

      <v-col cols="12">
        <v-text-field
                      v-model="medical_record.aid_equipments"
                      label="Utiliza equipamentos de auxílio"
                      placeholder="Exemplo: Óculos, Lentes de contato, Aparelhos dentários, Aparelhos de audição, Próteses, etc."
                      type="text"
                      :disabled="requestingApi"
                      hide-details
                      density="compact">
        </v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
                      v-model="medical_record.illnesses"
                      label="Doenças ocorridas ou em tratamento"
                      placeholder="Exemplo: Bronquite, Asma, Convulsões, Catapora, Caxumba, Sarampo, Sinusite, etc."
                      type="text"
                      :disabled="requestingApi"
                      hide-details
                      density="compact">
        </v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
                      v-model="medical_record.continuous_use_medications"
                      label="Medicamentos de uso contínuo"
                      placeholder="Exemplo: Amoxicilina, Aspirina, Omeprazol, etc."
                      type="text"
                      :disabled="requestingApi"
                      hide-details
                      density="compact">
        </v-text-field>
      </v-col>

      <v-col cols="12">
        <v-card
                title="Quem chamar em casos de emergências médicas?"
                color="grey-lighten-2">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                              v-model="medical_record.medical_emergencies_call_name"
                              label="Nome"
                              type="text"
                              :disabled="requestingApi"
                              density="compact">
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete
                                label="Tipo"
                                :items="[
                                  'Pai',
                                  'Mãe',
                                  'Tio(a)',
                                  'Avô(ó)',
                                  'Irmão(ã)',
                                  'Outro',
                                ]"
                                v-model="medical_record.medical_emergencies_call_type"
                                :disabled="requestingApi"
                                density="compact">
                  <template v-slot:no-data>
                    <div class="px-4">Digite sua busca</div>
                  </template></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                              v-model="medical_record.medical_emergencies_call_phone"
                              label="Fone"
                              placeholder="(xx) 00000 0000"
                              type="text"
                              :disabled="requestingApi"
                              density="compact">
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card
                title="Informações gerais"
                color="grey-lighten-2"
                class="text-black">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-switch
                          v-model="medical_record.gi_can_swim"
                          :label="medical_record.gi_can_swim ? 'Sim' : 'Não'"
                          color="red"
                          hide-details
                          density="compact"
                          :disabled="requestingApi">
                  <template v-slot:prepend>
                    <span> Sabe nadar ? </span>
                  </template>
                </v-switch>
                <v-switch
                          v-model="medical_record.gi_sleepwalk"
                          :label="medical_record.gi_sleepwalk ? 'Sim' : 'Não'"
                          color="red"
                          hide-details
                          density="compact"
                          :disabled="requestingApi">
                  <template v-slot:prepend>
                    <span> É sonâmbulo(a)? </span>
                  </template>
                </v-switch>
                <v-switch
                          v-model="medical_record.gi_physical_impediments"
                          :label="medical_record.gi_physical_impediments ? 'Sim' : 'Não'
                            "
                          color="red"
                          hide-details
                          density="compact"
                          :disabled="requestingApi">
                  <template v-slot:prepend>
                    <span> Possui algum impedimento físico? </span>
                  </template>
                </v-switch>
                <v-switch
                          v-model="medical_record.gi_dietary_restrictions"
                          :label="medical_record.gi_dietary_restrictions ? 'Sim' : 'Não'
                            "
                          color="red"
                          hide-details
                          density="compact"
                          :disabled="requestingApi">
                  <template v-slot:prepend>
                    <span> Possui alguma restrição alimentar? </span>
                  </template>
                </v-switch>
                <v-switch
                          v-model="medical_record.gi_heart_problems"
                          :label="medical_record.gi_heart_problems ? 'Sim' : 'Não'"
                          color="red"
                          hide-details
                          density="compact"
                          :disabled="requestingApi">
                  <template v-slot:prepend>
                    <span> Possui problemas cardíacos? </span>
                  </template>
                </v-switch>
              </v-col>
              <v-col cols="12">
                <v-text-field
                              v-model="medical_record.gi_allergies"
                              label="Alergias"
                              placeholder="Exemplo: Medicamentos, Plantas, Picadas e insetos, Alimentos, etc."
                              type="text"
                              :disabled="requestingApi"
                              hide-details
                              density="compact">
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                              v-model="medical_record.gi_physical_disabilities"
                              label="Deficiências"
                              type="text"
                              :disabled="requestingApi"
                              hide-details
                              density="compact">
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                            v-model="medical_record.gi_notes"
                            label="Observações"
                            placeholder="Outras observações"
                            counter
                            density="compact"
                            :disabled="requestingApi"></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card title="Documentos e atestados" color="grey-lighten-2">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <p class="text-overline">Adicionar documento</p>
                <UploadFile
                            icon="mdi-paperclip"
                            :fileType="$FILE_TYPE.medical_record"
                            :userId="user.id"
                            :legalPersonId="legalPerson?.id"
                            @uploaded="fileUploaded"
                            density="compact" />
              </v-col>
              <v-col cols="12" v-if="medicalFiles && medicalFiles.length > 0">
                <v-list lines="one" density="compact">
                  <v-list-item
                               v-for="(file, ixfl) in medicalFiles"
                               :key="ixfl"
                               :title="file.original_name">
                    <template v-slot:prepend>
                      <v-btn
                             :disabled="requestingApi"
                             color="red"
                             variant="text"
                             icon
                             size="medium"
                             class="mr-2"
                             density="compact"
                             @click="deleteFile(file, ixfl)"><v-icon>mdi-delete</v-icon></v-btn>
                    </template>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card color="grey-lighten-2">
          <v-card-text>
            <v-row>
              <v-col cols="12" v-if="medical_record.authorized">
                <p>
                  Data da primeira autorização:
                  <span
                        class="mx-2 font-weight-bold"
                        style="text-decoration: underline">{{
                          $moment(medical_record.authorized).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )
                        }}</span>
                </p>
                <p>
                  Data da última atualização:
                  <span
                        class="mx-2 font-weight-bold"
                        style="text-decoration: underline">{{
                          $moment(medical_record.updated_at).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )
                        }}</span>
                </p>
              </v-col>
              <v-col cols="12" v-else>
                Eu,
                <span
                      class="mx-2 font-weight-bold"
                      style="text-decoration: underline">{{ user?.legal_person?.name || legalPerson.name }}</span>, nesta
                data de
                <span
                      class="mx-2 font-weight-bold"
                      style="text-decoration: underline">{{ $moment(new Date()).format("DD/MM/YYYY") }}</span>
                às
                <span
                      class="mx-2 font-weight-bold"
                      style="text-decoration: underline">{{ $moment(new Date()).format("HH:mm:ss") }}</span>, confirmo e
                valido as informações presentes neste documento,
                autorizando a sua utilização no que se fizer necessário para
                fins relacionados às atividades desenvolvidas pelo grupo
                <span
                      class="mx-2 font-weight-bold"
                      style="text-decoration: underline">{{ groupName }}</span>
                <v-checkbox
                            :rules="rules.required"
                            label="Autorizar ficha médica"
                            v-model="medical_record_autorized"
                            density="compact"></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row density="compact" justify="end">
      <v-col cols="12" class="text-right mb-2" v-if="!medical_record.authorized">
        <v-btn color="success" type="submit" density="compact" :disabled="!api.storage.isGroupSelected()">
          <v-icon class="mr-2">mdi-content-save</v-icon>
          Autorizar ficha médica
        </v-btn>
      </v-col>
      <v-col cols="2" class="text-right mb-2" v-else>
        <v-btn color="info" density="compact"
               @click="printMedicalRecord()">
          <v-icon class="mr-2">mdi-download</v-icon>
          Baixar
        </v-btn>
      </v-col>
      <v-col cols="2" class="text-right mb-2" v-if="medical_record.authorized">
        <v-btn color="success" type="submit" density="compact">
          <v-icon class="mr-2">mdi-content-save</v-icon>
          Atualizar
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import ListFromTo from "./ListFromTo.vue";
import UploadFile from "./UploadFile.vue";
import api from '@/services'
import functions from '@/services/Functions'
export default {
  setup() {
    return { api }
  },
  components: { ListFromTo, UploadFile },
  props: {
    admin: Boolean,
    user: Object,
    legalPerson: Object,
  },
  data() {
    return {
      requestingApi: null,
      medical_record: {},
      medicalFiles: [],
      searchText: null,
      medical_record_autorized: false,
      rules: {
        required: [(v) => !!v || "Campo obrigatório"],
      },
    };
  },
  created() {
    var vm = this;

    vm.medical_record = vm.legalPerson?.medical_record || vm.generateEmpty();
    vm.loadMedicalFiles(vm.legalPerson?.files || [])
  },
  mounted() { },
  activated() { },
  methods: {
    submitUpdate() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.medicalRecord[vm.admin ? "updateAdmin" : "update"]({
          ...vm.medical_record,
          legal_person_id: vm.legalPerson.id
        }
        )
          .then((result) => {
            vm.$emit("updated", result);
            vm.$notify({
              type: "success",
              text: "Dados alterados com sucesso",
            });
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    loadMedicalFiles(files) {
      var vm = this
      vm.medicalFiles = files.filter(file => file.type == 7)
    },
    generateEmpty() {
      return {
        name: null,
        height: null,
        weight: null,
        blood_type: null,
        health_insurance_name: null,
        health_insurance_number: null,
        aid_equipments: null,
        illnesses: null,
        continuous_use_medications: null,
        medical_emergencies_call_name: null,
        medical_emergencies_call_type: null,
        medical_emergencies_call_phone: null,
        gi_can_swim: null,
        gi_sleepwalk: null,
        gi_physical_impediments: null,
        gi_dietary_restrictions: null,
        gi_heart_problems: null,
        gi_allergies: null,
        gi_physical_disabilities: null,
        gi_notes: null,
      };
    },
    fileUploaded(file) {
      var vm = this;
      vm.medicalFiles.push(file);
    },
    deleteFile(file, index) {
      var vm = this;
      let _confirm = confirm(
        `Deseja realmente escluir o arquivo ${file.original_name}`
      );
      if (_confirm) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.file
            .delete(file)
            .then((result) => {
              vm.medicalFiles.splice(index, 1);
              vm.$notify({
                type: "success",
                text: "Arquivo removido",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    printMedicalRecord() {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.pdf
            .downloadMedicalRecord({
              ...vm.medical_record,
              legal_person_id: vm.legalPerson.id
            }).then((result) => {
              // // create file link inx browser's memory
              // const href = URL.createObjectURL(result);

              // let objFra = document.createElement('iframe');     // Create an IFrame.
              // objFra.style.visibility = 'hidden';                // Hide the frame.
              // objFra.src = href;                   // Set source.

              // document.body.appendChild(objFra);  // Add the frame to the web page.

              // objFra.contentWindow.focus();       // Set focus.
              // objFra.contentWindow.print();       // Print it.

              // document.body.removeChild(objFra);
              // URL.revokeObjectURL(href);

              // create file link inx browser's memory
              const href = URL.createObjectURL(result);

              // create "a" HTML element with href to file & click
              const link = document.createElement('a');
              link.href = href;

              link.setAttribute('download', `FichaMedica_${vm.$moment(new Date()).format("YYYYMMDD-HH-mm-ss")}.pdf`); //or any other extension
              document.body.appendChild(link);
              link.click();

              // clean up "a" element & remove ObjectURL
              document.body.removeChild(link);
              URL.revokeObjectURL(href);
            }).catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    }
  },
  computed: {
    groupName() {
      const vm = this;
      let ret = 'GRUPO NÃO SELECIONADO';

      if (api.storage.isGroupSelected()) {
        ret = api.storage.selectedGroup().name;
      }

      return ret;
    }
  },
  watch: {
    legalPerson(newVal) {
      this.medical_record = newVal?.medical_record || this.generateEmpty();
      this.medical_record_autorized = newVal?.medical_record?.authorized || false;
    },
  },
};
</script>